import { render } from "./g-account-userpassword_change.vue?vue&type=template&id=d29c76fa&ts=true"
import script from "./g-account-userpassword_change.vue?vue&type=script&lang=tsx"
export * from "./g-account-userpassword_change.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__